import { render } from "./ProductToolbar.vue?vue&type=template&id=6c1e1c82&scoped=true"
import script from "./ProductToolbar.vue?vue&type=script&lang=js"
export * from "./ProductToolbar.vue?vue&type=script&lang=js"

import "./ProductToolbar.vue?vue&type=style&index=0&id=6c1e1c82&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1e1c82"]])

export default __exports__